/**
 * Helpers para razonar sobre la sesión guardada en `localStorage`, que es
 * compartida por todas las pestañas del mismo origen (a diferencia del Redux en
 * memoria de cada una).
 *
 * - `tokens`: lo escribe `api.js` (`setTokens`/`clearAuth`).
 * - `persist:root`: lo escribe `redux-persist`. `profile` va serializado como
 *   string dentro del JSON.
 */

/** Email de `profile` dentro de un valor crudo de `persist:root`. Nunca lanza. */
export function readPersistedEmail(raw) {
  if (!raw) return ''
  try {
    const root = JSON.parse(raw)
    const profile = typeof root?.profile === 'string' ? JSON.parse(root.profile) : root?.profile
    const email = profile?.email
    return typeof email === 'string' ? email : ''
  } catch {
    return ''
  }
}

/** `true` si `raw` (valor crudo de `tokens`) contiene un `access-token`. Nunca lanza. */
export function tokensHaveAccessToken(raw) {
  if (!raw) return false
  try {
    return !!JSON.parse(raw)?.['access-token']
  } catch {
    return false
  }
}

export function hasStoredTokens() {
  return tokensHaveAccessToken(localStorage.getItem('tokens'))
}

export function getPersistedEmail() {
  return readPersistedEmail(localStorage.getItem('persist:root'))
}

/**
 * Hay una sesión viva guardada: tokens con `access-token` Y un perfil
 * persistido con email. Si falta cualquiera de los dos (p. ej. tokens viejos
 * con `persist:root` borrado) no cuenta como sesión viva.
 */
export function hasLiveSessionInStorage() {
  return hasStoredTokens() && getPersistedEmail() !== ''
}

/**
 * `Login.handleEmail` limpia tokens y `domain` al editar el email. Eso solo es
 * seguro si ninguna otra pestaña tiene una sesión viva: `clearAuth()` escribe en
 * el `localStorage` compartido y mataría la sesión de esa pestaña.
 */
export function shouldResetAuthOnEmailChange() {
  return !hasLiveSessionInStorage()
}
